import React from 'react';
import styled from 'styled-components';
import { Button, Tooltip } from 'antd';
import { CodeOutlined } from '@ant-design/icons';

import UsersQueryExposureModal from '../../containers/users/UsersQueryExposureModal';
import DocsLink from '../docs/DocsLink';
import docsBookmarks from '../../constants/docs';

const StyledUsersHeader = styled.h3`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .header-options {
    display: flex;
    flex-direction: row;
  }
`;

const StyledButton = styled(Button)`
  border: none;
  background-color: transparent;
  margin-left: 10px;
`;

const UsersHeader = () => {
  const renderButton = (onClick, userEvent) => (
    <Tooltip placement="top" title="Expose a query">
      <StyledButton
        icon={<CodeOutlined />}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
          e.target.blur();
        }}
        disabled={!userEvent}
      />
    </Tooltip>
  );

  return (
    <StyledUsersHeader>
      Event
      <div className="header-options">
        <UsersQueryExposureModal button={renderButton} />
        <DocsLink scrolTo={docsBookmarks.users} styleIcon={{ fontSize: 20, color: 'gray' }} />
      </div>
    </StyledUsersHeader>
  );
};

export default UsersHeader;
